module.exports = __webpack_public_path__ + "static/media/bgmodalred.0b7c190f.PNG";